const state = () => ({
    item: null
});

const mutations =
    {
        setItemPreview(state, item)
        {
            if (item)
            {
                state.item = item;
            }
        }
    };

const actions = {
    setItemPreviewDetails({ commit, dispatch }, itemPreviewDetails)
    {
        commit("setItemPreview", itemPreviewDetails.item);
    }
};

export default
{
    state,
    mutations,
    actions
};
